import { render, staticRenderFns } from "./WhyAUMistheWrongMetricinVC.vue?vue&type=template&id=1014537a"
import script from "./WhyAUMistheWrongMetricinVC.vue?vue&type=script&lang=js"
export * from "./WhyAUMistheWrongMetricinVC.vue?vue&type=script&lang=js"
import style0 from "./WhyAUMistheWrongMetricinVC.vue?vue&type=style&index=0&id=1014537a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports